var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 97.396 97.396",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.247,16.472h-6.5v-9.18c0-2.419-1.969-4.388-4.387-4.388H54.344V1.95c0-1.077-0.873-1.95-1.95-1.95h-18.28 c-1.077,0-1.95,0.873-1.95,1.95v0.954H18.148c-2.419,0-4.387,1.968-4.387,4.388V79.44c0,2.419,1.968,4.387,4.387,4.387h6.501 v9.181c0,2.42,1.968,4.388,4.387,4.388h50.211c2.42,0,4.388-1.968,4.388-4.388V20.86C83.635,18.441,81.667,16.472,79.247,16.472z  M24.649,20.86v58.093h-6.013V7.78h13.527v0.583c0,1.077,0.873,1.95,1.95,1.95h18.28c1.077,0,1.95-0.873,1.95-1.95V7.78H67.87 v8.693h-2.641v-0.955c0-1.077-0.873-1.95-1.949-1.95H45c-1.077,0-1.95,0.873-1.95,1.95v0.954H29.036 C26.617,16.472,24.649,18.441,24.649,20.86z M78.76,92.521H29.523V21.347h13.528v0.583c0,1.077,0.873,1.95,1.95,1.95H63.28 c1.078,0,1.951-0.874,1.951-1.95v-0.583h13.526v71.173H78.76z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.242,
    y: 59.707,
    width: 33.798,
    height: 6.825
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.242,
    y: 73.682,
    width: 33.798,
    height: 6.826
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.136,52.396 57.147,52.396 57.147,44.757 64.786,44.757 64.786,38.745 57.147,38.745 57.147,31.108  51.136,31.108 51.136,38.745 43.499,38.745 43.499,44.757 51.136,44.757  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicjs);
export default __webpack_public_path__ + "static/media/clinicjs.feeca6621ce3797d027c8e7cb2e95db0.svg";
export { ForwardRef as ReactComponent };